import { render, staticRenderFns } from "./CardTodo.vue?vue&type=template&id=f360d056&scoped=true"
import script from "./CardTodo.vue?vue&type=script&lang=ts"
export * from "./CardTodo.vue?vue&type=script&lang=ts"
import style0 from "./CardTodo.vue?vue&type=style&index=0&id=f360d056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f360d056",
  null
  
)

export default component.exports